import { ExclamationLg } from "react-bootstrap-icons"

export const FailedIcon = () => {
  
  return <div className="size-10 rounded-full flex items-center justify-center ring-inset ring-2 ring-red-100 bg-[#E06363]">
    <ExclamationLg className="size-6 text-white text-xl" />
  </div>
}

